<template>
  <div class="flex flex-wrap -mx-1">
    <div class="w-1/5 p-1" v-for="(n, index) in 10" :key="index">
      <vue-button type="button"
                  :disabled="disabled"
                  class="w-full btn btn-primary btn-outline"
                  @click="$emit('input', index)">{{ index }}</vue-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
